import { Outlet, useRoutes, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './Component/Layout'
import AboutUsPage from './Pages/Aboutus/Aboutus'
import ActivityPage from './Pages/Activities/Activity'
import { ActivityProvider } from './Component/context_components/activities_context'
import ContactUsPage from './Pages/Contactus/Contactus'
// import { Button } from '@mui/material'
// import CoursePage from "./Pages/Course/Course";
// import CourseOfferingPage from "./Pages/Course_Offering/Course_Offering";
import CourseOfferedPage from './Pages/Department/Department.js'
import HomePage from './Pages/Home'
import FacultyPage from './Pages/Faculty/Faculty'
import AdminAccountsPage from './Pages/Academics/AdminAccounts'
import SyllabusPage from './Pages/Academics/syllabusView'
import AcademicCalendar from './Pages/Academics/AcademicCalendar'
import NIRFComponentPage from './Pages/NACC/NACC.js'
import NIRFExtendedPage from './Pages/NACC/NIRFExtended.js'
// import FeedbackPage from './Pages/Feedback/Feedback'
import PlacementsPage from './Pages/Placements/placements'
// import AboutIQACPage from './Pages/IQAC/AboutIQAC'
// import IQACObjectivePage from './Pages/IQAC/IQAC_Objective'
// import IQACParameterPage from './Pages/IQAC/IQAC_Parameters'
// import QualityPolicyPage from './Pages/IQAC/Quality_Policy'
// import MandatoryDocPage from './Pages/IQAC/Mandatory_doc'
// import WorkingCommitteePage from './Pages/IQAC/Working_Commitee'
import InfrastructurePage from './Pages/Aboutus/Infrastructure'
import AllStudentsPage from './Pages/Placements/allstudentsplacedlist'
import BulletContentSection from './Pages/BulletContentSection/BulletContentSection.js'
import FileViewer from './Component/FileViewer/DynamicFileViewer'
import Error404 from './Error404'
// import SocialBar from './Component/Socialbar/Socialbar.js'
// import WelcomeModal from './Component/WelcomeModal.js'

// import NCC from "./Pages/StudentCorner/NCC";
// import NSS from "./Pages/StudentCorner/NSS";
// import Sports from "./Pages/StudentCorner/Sports";
import './App.css'

const AppRoutes = () => {
  // const [welcomeModalOpen, setWelcomeModalOpen] = useState(true)
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  // const handleCloseWelcomeModal = () => {
  //   setWelcomeModalOpen(false)
  // }

  const routesNav = [
    { element: <HomePage />, path: '/' },
    { element: <HomePage />, path: '/home' },
    { element: <CourseOfferedPage />, path: '/courseoffering/:name/:subname' },
    // { element: <CoursePage />, path: "/course" },
    { element: <AcademicCalendar />, path: '/academic_calendar' },
    { element: <FacultyPage />, path: '/faculty' },
    { element: <AdminAccountsPage />, path: '/accounts_admin_staff' },
    { element: <SyllabusPage />, path: '/syllabus' },
    { element: <AboutUsPage />, path: '/aboutus' },
    {
      element: (
        <ActivityProvider pageName="activities">
          <ActivityPage />
        </ActivityProvider>
      ),
      path: '/activity',
    },
    { element: <ContactUsPage />, path: '/contactus' },
    { element: <NIRFComponentPage />, path: '/nirf' },
    { element: <NIRFExtendedPage />, path: '/NIRFExtended' },
    {
      element: <BulletContentSection pageId="admissions" />,
      path: '/admissions',
    },
    {
      element: <BulletContentSection pageId="Engagements" />,
      path: '/student_engagement',
    },
    {
      element: <BulletContentSection pageId="facilities" />,
      path: '/resources',
    },
    {
      element: <BulletContentSection pageId="softSkills" />,
      path: '/softskills',
    },

    {
      element: <BulletContentSection pageId="internships" />,
      path: '/internships',
    },

    {
      element: <BulletContentSection pageId="techintegration" />,
      path: '/techintegration',
    },
    {
      element: <BulletContentSection pageId="eliteStudents" />,
      path: '/studentcorner',
    },
    {
      element: <FileViewer backButton="/" />,
      path: '/aicte/eoa/*',
    },
    {
      element: <FileViewer backButton="/" />,
      path: '/IIC/*',
    },
    {
      element: <FileViewer backButton="/" />,
      path: '/aicte/anti_ragging_cell/*',
    },
    {
      element: <FileViewer backButton="/" />,
      path: '/aicte/greivance_rederessal_cell/*',
    },
    {
      element: <FileViewer backButton="/" />,
      path: '/aicte/pio_apio/*',
    },
    {
      element: <FileViewer backButton="/" />,
      path: '/aicte/women_cell/*',
    },
    {
      element: <FileViewer backButton="/faculty" />,
      path: '/*',
    },
    {
      element: <FileViewer backButton="/syllabus" />,
      path: '/syllabus/*',
    },
    {
      element: <FileViewer backButton="/academic_calendar" />,
      path: '/academic_calendar/*',
    },
    // { element: <AboutIQACPage />, path: '/aboutIQAC' },
    // { element: <IQACObjectivePage />, path: '/IQACObjective' },
    // { element: <IQACParameterPage />, path: '/IQACParameter' },
    // { element: <QualityPolicyPage />, path: '/Qualitypolicy' },
    // { element: <MandatoryDocPage />, path: '/mandatorydoc' },
    // { element: <WorkingCommitteePage />, path: '/workingcommitee' },
    // { element: <FeedbackPage />, path: '/feedback' },
    { element: <InfrastructurePage />, path: '/infrastructure' },
    { element: <PlacementsPage />, path: '/placements' },
    { element: <AllStudentsPage />, path: '/allStudents' },
    { element: <Error404 />, path: '*' },

    // { element: <NCC />, path: "/NCC" },
    // { element: <NSS />, path: "/NSS" },
    // { element: <Sports />, path: "/sports" },
  ]

  const routesData = [
    {
      element: <Layout />,
      children: [
        {
          element: <Outlet />,
          children: routesNav,
        },
      ],
    },
  ]

  return (
    <div>
      {' '}
      {/* Use a container for styling */}
      {useRoutes(routesData)}
      {/* <WelcomeModal open={welcomeModalOpen} onClose={handleCloseWelcomeModal} /> */}
      {/* <SocialBar /> */}
    </div>
  )
}

export default AppRoutes
